<template>
	<div>
		<myheader :backFlag="true" :myBackgroundColor="'#98e2af'" headTitle="签约减碳助力值"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back" style="background-color: #98e2af;"></div>
			<div class="header_extend_content_height" style="height: 80vh;overflow-y: auto;">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div class="all_tips_content_card_padding8">
						<div class="all_text_center">
							<div class="text14 textcolor666 font_weight_bold margin_bottom_10">{{corpName}}</div>
							<div class="text14 textcolor666 font_weight_bold margin_bottom_10">在石化e签平台，您已累计减少碳排放</div>
							<div class="text24 textcolor98e2af font_weight_bold margin_bottom_10">
								{{(Tool.isNoEmpty(corpScore)?corpScore:'0')+'g'}}
							</div>
						</div>
						<van-list v-model="listloading" :finished="listfinished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div style="width: 90%;margin: 0 5% 1rem;" v-for="(item,index) in list" :key="index">
								<div class="all_height20 display_flex backgroundC_98e2af"
									style="border-radius: .2rem;align-items: center;">
									<span class="display_block text14 textcolor333 font_weight_bold"
										style="width: 35%;margin-left: 5%;">{{Tool.isNoEmpty(item.year)?item.year:'2024'}}</span>
									<span class="display_block text12 textcolor333 all_text_right"
										style="width: 33%;margin-right: 2%;">节能减碳</span>
									<span class="display_block text14 textcolor333 font_weight_bold all_text_right"
										style="width: 25%;padding-right: .5rem;">{{'+'+(Tool.isNoEmpty(item.corpScore)?item.corpScore:'0')+'g'}}</span>
								</div>
								<!-- <div v-show="false">
									<div class="all_height20 margin_top_10" style="padding: 0 .5rem;"
										v-for="(child,cindex) in item.list" :key="cindex">
										<div class="display_flex">
											<span class="display_block text12 textcolor666"
												style="width: 90%;">中国石化示范合同一</span>
											<span class="display_block text12 textcolor333 font_weight_bold"
												style="width: 10%;">+2g</span>
										</div>
										<div class="margin_bottom_3 text12 textcolor666 margin_top_5">9-20</div>
									</div>
									<div class="margin_top_10 all_text_center text12 textcolor98e2af">
										<span
											style="border: 1px solid #98e2af;border-radius: .8rem;padding: .3rem .5rem; "
											@click="loadShowMore(index)">展开更多</span>
									</div>
								</div> -->
							</div>
						</van-list>
						<van-empty style="margin-top: 10vh;" description="暂无数据" v-show="list.length===0" />
					</div>
				</van-pull-refresh>
			</div>
			<!-- <div style="position: fixed; bottom: 1rem; left: 0;right: 0;">
				<span class="text12 textcolor98e2af all_text_center display_block"
					style="position: relative; width: 60%;left: 20%;">签约减碳计算模型由石化e签联合北京绿色交易所提供</span>
			</div> -->
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Empty,
		PullRefresh,
		List,
	} from 'vant';
	export default {
		components: {
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
			[List.name]: List,
		},
		data() {
			return {
				//
				//企业id
				corpId: '',
				//
				corpName: '',
				//
				corpScore: '',
				//每页数量
				pageSize: 10,
				//第几页
				pageNum: 0,
				//是否刷新
				refreshing: false,
				//加载中
				listloading: false,
				//是否全部加载
				listfinished: false,
				//
				list: [],
			}
		},
		methods: {
			//
			loadShowMore(index) {

			},
			//
			onRefresh() {
				this.$store.dispatch(this.$LoadShow, true)
				this.listfinished = false;
				// 将 loading 设置为 true，表示处于加载状态
				this.listloading = true;
				this.pageNum = 0
				this.onLoad();
			},
			//
			onLoad() {
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.pageNum++
				this.queryCorpScoresStatYear()
			},
			//
			queryCorpScoresStatYear() {
				this.$post('/score/m/api/queryCorpScoresStatYear', {
					corpId: this.corpId,
					pageParams: {
						current: this.pageNum,
						desc: true,
						orderBy: "",
						size: this.pageSize
					}
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.list = this.list.concat(res.data.records);
						// 加载状态结束
						this.listloading = false;
						//数据全部加载完成
						if (this.list.length >= res.data.total) {
							this.listfinished = true;
						}
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
				})
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				this.corpScore = this.$route.query.corpScore
				this.onRefresh()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>